export default __webpack_public_path__ + "static/media/scotch.446a79ea.webp";